// extracted by mini-css-extract-plugin
module.exports = {"title":"room_title_title__29Ykl","container":"room_title_container__161sz","promotion":"room_title_promotion__24hmc"};